"use client";

import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { ensureVigilabI18n } from "@/lib/vigilabI18n";

/**
 * Donne à la modale Vigilab sa propre instance i18next (KN-1557) : français par
 * défaut, choix mémorisé à part, sans effet sur la langue de l'application.
 * Le Suspense couvre le chargement des catalogues à la première ouverture.
 */
export default function VigilabI18nProvider({
  children,
  fallback = null,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  return (
    <I18nextProvider i18n={ensureVigilabI18n()}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </I18nextProvider>
  );
}
